import * as React from "react";

import { NotAuthorized } from "@/features/error";

import { useAuthorization } from "../hooks/useAuthorization";
import type { Role } from "../types";

type AuthorizationProps = {
  forbiddenFallback?: React.ReactNode;
  children: React.ReactNode;
  allowedRoles: Role[];
};

export const Authorization = ({
  allowedRoles,
  children,
  forbiddenFallback = <NotAuthorized />,
}: AuthorizationProps) => {
  const { checkAccess } = useAuthorization();

  let canAccess = false;

  if (allowedRoles) {
    canAccess = checkAccess({ allowedRoles });
  }

  return <>{canAccess ? children : forbiddenFallback}</>;
};
